import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import { NotificationProgrammatic } from 'buefy';

import FlowrightAddress from '@/components/address/FlowrightAddress.vue';

import type { JobSite } from '@/types/JobSite';


export default /*#__PURE__*/_defineComponent({
  __name: 'JobSiteModal',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["close", "save"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close', value: boolean): void;
  (e: 'save', jobSite: JobSite): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isOpen: boolean;
}





const addressForm = ref(null);
const saving = ref(false);

const isActive = computed({
  get: () => props.isOpen,
  set: value => emit('close', value),
});

const jobSite = ref<Partial<JobSite>>({
  ezCare: 'none',
  ezCareStartDate: null,
});

const closeModal = () => {
  isActive.value = false;
  // Reset form
  jobSite.value = {
    ezCare: 'none',
    ezCareStartDate: null,
  };
};

const validateForm = (): boolean => {
  const hasEzCare = jobSite.value.ezCare !== 'none';
  // Validate required fields
  if (
    !jobSite.value.street ||
    !jobSite.value.city ||
    !jobSite.value.state ||
    !jobSite.value.zip ||
    (hasEzCare && !jobSite.value.ezCareStartDate)
  ) {
    NotificationProgrammatic.open({
      message: 'Please fill out all required fields',
      type: 'is-danger',
    });
    return false;
  }

  return true;
};

const saveJobSite = async () => {
  if (!validateForm()) {
    return;
  }

  saving.value = true;
  const savingJobSite = { street2: '', ...jobSite.value } as JobSite;
  try {
    emit('save', savingJobSite);
    closeModal();
  } finally {
    saving.value = false;
  }
};

return { __sfc: true,props, emit, addressForm, saving, isActive, jobSite, closeModal, validateForm, saveJobSite, FlowrightAddress }
}

})